import NotificationDateSeparatorComponent from './notification-date-separator.component'

const NotificationDateSeparatorModule = angular.module('cdbl.notification-date-separator', [

])
  .component('cdblNotificationDateSeparator', NotificationDateSeparatorComponent)
  .name

export default NotificationDateSeparatorModule
